import React from 'react'

export default () => (
  <div>
  </div>
)



// WEBPACK FOOTER //
// ./src/containers/About/index.js